// src/utils/relicVault/relicDisplay.js
//
// Lookup helpers shared by the store and the vault browser, so both derive the
// same guild / rarity display data from one catalog. Ported from the designer's
// handoff (lib/relicDisplay.ts).

import { GUILD_DEFS, TIERS, RELIC_DESCRIPTIONS } from 'config/relicVault/guilds';
import { RELIC_CATALOG } from 'config/relicVault/relics';

const guildIndex = new Map(GUILD_DEFS.map(g => [g.id, g]));
const tierIndex = new Map(TIERS.map(t => [t.key, t]));
const relicIndex = new Map(RELIC_CATALOG.map(r => [r.id, r]));

export function getRelic(id) {
  return relicIndex.get(id);
}

export function guildById(id) {
  return guildIndex.get(id);
}

export function tierByKey(key) {
  return tierIndex.get(key);
}

/** GUILD_DEFS.title is already the full name ("Victory Guild", "Secret Society"). */
export function guildLabelFor(relic) {
  const guild = guildById(relic.guild);
  return guild ? guild.title : '';
}

export function rarityColorFor(relic) {
  return tierByKey(relic.rarity)?.color ?? '#8B5CF6';
}

/** Name shown for a relic the player hasn't discovered, e.g. "Undiscovered Legendary Relic". */
export function undiscoveredName(relic) {
  return `Undiscovered ${relic.rarityLabel} Relic`;
}

/** Vault detail copy: the real description if owned, otherwise a tier-appropriate hint. */
export function detailDescriptionFor(relic) {
  if (relic.owned) return relic.desc;
  if (relic.rarity === 'mythic') return RELIC_DESCRIPTIONS.lockedMythic;
  if (relic.rarity === 'legendary') return RELIC_DESCRIPTIONS.lockedLegendary;
  if (relic.rarity === 'epic') return RELIC_DESCRIPTIONS.lockedEpic;
  return RELIC_DESCRIPTIONS.lockedLow;
}
